import { Button, CrossIcon, Divider, Text } from 'chemistry'
import classNames from 'classnames'
import { dictionary } from 'client/common/accessability'
import Sorting from 'client/fragments/listerFragment/components/Sorting/Sorting'
import { getProductCountText } from 'client/fragments/listerFragment/selectors/translations'
import { handleHintClick } from 'client/fragments/listerFragment/store/middleware/gtm'
import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { pushAllFiltersEvent } from '../../../../../common/gtmEvents'
import ActiveFilters from './ActiveFilters'
import { FiltersList } from './FiltersList'

export const FiltersSide = ({
  filters: { collection, active },
  filterProcessedData: {
    onChange,
    onClear,
    preventClick,
    format,
    lang,
    t,
    buttonActiveText,
    buttonInactiveText,
    rangeFilterToText
  },
  filtersToggled,
  setFiltersToggled,
  disabled,
  showSorting
}) => {
  const closeFilters = useCallback(() => {
    setFiltersToggled(false)
  }, [setFiltersToggled])

  const closeFiltersNewListerView = useCallback(() => {
    closeFilters()
    pushAllFiltersEvent('close')
  }, [closeFilters])
  const quantity = useSelector(store => store.data.products.quantity)
  const useAlgolia = useSelector(store => store.data?.flags?.useAlgolia)

  const showText = t('lister.filters.show')
  const showTextCapitalized = showText[0].toUpperCase() + showText.slice(1)

  return (
    <>
      <div
        onClick={closeFiltersNewListerView}
        data-toggle-active={filtersToggled}
        className='mxd-lister-filters-background'
      />
      <div
        data-toggle-active={filtersToggled}
        className={classNames(
          {
            'mxd-disabled': disabled
          },
          'mxd-lister-filters-panel-new-lister-view'
        )}
        inert={!filtersToggled ? '' : undefined}
      >
        <div className={'mxd-lister-filters'}>
          {disabled && <div className='disabled-overlay' />}
          <header className='flex justify-between items-center'>
            <Text as='h2' fontSize='2xl' fontFamily='bold'>
              {t('lister.filters.filters')}
            </Text>
            <button onClick={closeFiltersNewListerView} title={dictionary(lang).closeAllFilters}>
              <CrossIcon />
            </button>
          </header>
          <Divider my='1.5em' />
          {Object.keys(active)?.length > 0 && (
            <ActiveFilters collection={active} onRemove={onChange} onClear={onClear} />
          )}
          {showSorting && <Sorting id='sorting_side' isFilterPanel className='pb-1-5' />}
          {filtersToggled && collection?.length > 0 && (
            <FiltersList
              filters={useAlgolia ? collection.filter(f => f.name !== 'product_review_rating') : collection}
              active={active}
              onHintClick={handleHintClick}
              onChange={onChange}
              closeFiltersNewListerView={closeFiltersNewListerView}
              preventClick={preventClick}
              buttonActiveText={buttonActiveText}
              buttonInactiveText={buttonInactiveText}
              rangeFilterToText={rangeFilterToText}
              format={format}
              lang={lang}
            />
          )}
        </div>
        <footer>
          <Button
            width='100%'
            height='48px'
            variant='primarySmall'
            onClick={() => {
              setFiltersToggled(false)
            }}
          >
            {showTextCapitalized} {quantity} {getProductCountText(t, quantity)}
          </Button>
        </footer>
      </div>
    </>
  )
}
